import React, { useState, useEffect } from 'react';
import { apiService } from '../services/api';

const Solutions = () => {
  const [solutions, setSolutions] = useState([
    {
      id: 1,
      title: 'Cloud & Infrastructure',
      icon: 'fas fa-cloud',
      iconColor: 'text-primary',
      bgColor: 'bg-blue-100',
      technologies: [
        { name: 'AWS / Azure / GCP', icon: 'fab fa-aws', color: 'text-orange-500' },
        { name: 'Docker & Kubernetes', icon: 'fab fa-docker', color: 'text-blue-500' },
        { name: 'Terraform & Ansible', icon: 'fas fa-server', color: 'text-gray-600' },
        { name: 'CDN & Load Balancing', icon: 'fas fa-network-wired', color: 'text-green-500' }
      ]
    },
    {
      id: 2,
      title: 'Development Stack',
      icon: 'fas fa-code',
      iconColor: 'text-purple-600',
      bgColor: 'bg-purple-100',
      technologies: [
        { name: 'Node.js / React / Vue.js', icon: 'fab fa-js-square', color: 'text-yellow-500' },
        { name: 'Python / Django / FastAPI', icon: 'fab fa-python', color: 'text-blue-500' },
        { name: 'PostgreSQL / MongoDB', icon: 'fas fa-database', color: 'text-green-500' },
        { name: 'Mobile & Progressive Web Apps', icon: 'fas fa-mobile-alt', color: 'text-purple-500' }
      ]
    },
    {
      id: 3,
      title: 'Security & DevOps',
      icon: 'fas fa-shield-alt',
      iconColor: 'text-accent',
      bgColor: 'bg-green-100',
      technologies: [
        { name: 'Jenkins / GitHub Actions', icon: 'fab fa-jenkins', color: 'text-red-500' },
        { name: 'Monitoring & Alerting', icon: 'fas fa-eye', color: 'text-blue-500' },
        { name: 'OAuth / JWT / Encryption', icon: 'fas fa-lock', color: 'text-green-500' },
        { name: 'Automated Testing & QA', icon: 'fas fa-bug', color: 'text-orange-500' }
      ]
    }
  ]);

  useEffect(() => {
    const fetchSolutions = async () => {
      try {
        const response = await apiService.getSolutions();
        if (response.data && response.data.length > 0) {
          setSolutions(response.data);
        }
      } catch (error) {
        console.log('Using default solutions data');
      }
    };

    fetchSolutions();
  }, []);

  return (
    <section id="solutions" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Technology Solutions Stack
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Leveraging cutting-edge technologies and industry best practices to deliver 
            robust, scalable, and future-ready solutions.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {solutions.map((solution) => (
            <div
              key={solution.id}
              className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow"
            >
              <div className="flex items-center mb-6">
                <div className={`${solution.bgColor} w-12 h-12 rounded-lg flex items-center justify-center mr-4`}>
                  <i className={`${solution.icon} text-xl ${solution.iconColor}`}></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900">{solution.title}</h3>
              </div>
              <div className="space-y-4">
                {solution.technologies.map((tech, index) => (
                  <div key={index} className="flex items-center">
                    <i className={`${tech.icon} ${tech.color} mr-3`}></i>
                    <span className="text-gray-700">{tech.name}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Solutions;
